



document.addEventListener("DOMContentLoaded", () => {
  // Captura a URL original da página no momento do carregamento
  const originalProductPath = window.location.pathname;
  console.log("URL original da página:", originalProductPath);

  const productKitData = document.getElementById("product-kit-data");
  const dataProductUrl = productKitData ? productKitData.getAttribute("data-product-url") : null;

  // Função para verificar e restaurar a URL original
  function checkAndRestoreUrl() {
    const currentPath = window.location.pathname;

    // Se o caminho atual não for igual à URL original, restaura-o
    if (currentPath !== originalProductPath) {
      history.replaceState(null, "", originalProductPath);
      console.log("URL restaurada para o valor original:", originalProductPath);
    }
  }

  // Observa mudanças no histórico de navegação
  window.addEventListener("popstate", checkAndRestoreUrl);
  window.addEventListener("pushState", checkAndRestoreUrl);
  window.addEventListener("replaceState", checkAndRestoreUrl);

  // Opcional: Verifica se a URL no atributo `data-product-url` corresponde à original
  if (dataProductUrl) {
    const fullDataUrl = new URL(dataProductUrl, window.location.origin).pathname;
    console.log("URL do atributo data-product-url:", fullDataUrl);
    if (fullDataUrl !== originalProductPath) {
      console.warn("A URL original da página é diferente do data-product-url.");
    }
  }
});



// Intercepta pushState e replaceState para disparar eventos personalizados
(function() {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function(...args) {
    originalPushState.apply(this, args);
    window.dispatchEvent(new Event("pushState"));
  };

  history.replaceState = function(...args) {
    originalReplaceState.apply(this, args);
    window.dispatchEvent(new Event("replaceState"));
  };
})();



document.addEventListener("DOMContentLoaded", function () {
  console.log("Kit Products JS carregado corretamente.");
  let itemSelecionado = "Filho 1";
  console.log("Estado inicial do itemSelecionado:", itemSelecionado);
  var selectedVariations = [];
  // Acessa o valor do data-max-selections e converte para um inteiro
const maxSelections = parseInt(document.getElementById("variant-counter").getAttribute("data-max-selections"), 10);

// Exibe no console ou usa como necessário
console.log("Máximo de seleções permitidas:", maxSelections);

  var currentSelectedVariant = null;
  var currentArrayPosition = 1;
  const elementos = document.querySelectorAll(".product-variant-picker__list");
  const filho1Contents = document.querySelectorAll(".filho1-content");
  const filho2Contents = document.querySelectorAll(".filho2-content");
  let isSimulatedClick = false;
  let isChangeClick = false;
  var specificVariant = [];

  function ativarCarrossel() {
    // Seleciona todos os elementos das classes especificadas
    const itens = document.querySelectorAll(
      '.filho1-content-animation, .product-media-carousel, .product-media-carousel-mo' +
      'bile__carousel'
    );

    itens.forEach((item) => {
      // Passo 1: Mover o item um pouco para a direita com fade out
      item.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
      item.style.transform = 'translateX(30%)'; // Move para a direita
      item.style.opacity = '0'; // Faz fade out

      // Passo 2: Pausa curta após o movimento para a direita
      setTimeout(() => {
        // Passo 3: Reposiciona o item instantaneamente à esquerda, mantendo-o invisível
        item.style.transition = 'none'; // Remove a transição para reposicionamento imediato
        item.style.transform = 'translateX(-30%)'; // Coloca o item à esquerda da posição original
        item.style.opacity = '0'; // Mantém invisível

        // Pausa curta para garantir a posição antes de aplicar a próxima transição
        setTimeout(() => {
          // Passo 4: Mover o item de volta para a posição inicial com fade in
          item.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
          item.style.transform = 'translateX(0)'; // Retorna à posição inicial
          item.style.opacity = '1'; // Faz fade in
        }, 50); // Pausa curta antes do retorno com fade in
      }, 250); // Duração do movimento inicial para a direita
    });
  }

  function voltarCarrossel() {
    // Seleciona todos os elementos das classes especificadas
    const itens = document.querySelectorAll(
      '.filho1-content-animation, .product-media-carousel, .product-media-carousel-mo' +
      'bile__carousel'
    );

    itens.forEach((item) => {
      // Passo 1: Mover o item um pouco para a esquerda com fade out
      item.style.transition = 'transform 0.3s ease-in-out, opacity 0.5s ease-in-out';
      item.style.transform = 'translateX(-30%)'; // Move para a esquerda
      item.style.opacity = '0'; // Faz fade out

      // Passo 2: Pausa curta após o movimento para a esquerda
      setTimeout(() => {
        // Passo 3: Reposiciona o item instantaneamente à direita, mantendo-o invisível
        item.style.transition = 'none'; // Remove a transição para reposicionamento imediato
        item.style.transform = 'translateX(30%)'; // Coloca o item à direita da posição original
        item.style.opacity = '0'; // Mantém invisível

        // Pausa curta para garantir a posição antes de aplicar a próxima transição
        setTimeout(() => {
          // Passo 4: Mover o item de volta para a posição inicial com fade in
          item.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
          item.style.transform = 'translateX(0)'; // Retorna à posição inicial
          item.style.opacity = '1'; // Faz fade in
        }, 50); // Pausa curta antes do retorno com fade in
      }, 250); // Duração do movimento inicial para a esquerda
    });
  }



  // Função para atualizar o contador inicialmente
  function updateCounterInicial() {
    var counterText = "Selecionando " + currentArrayPosition + " de " +
      maxSelections + " peças";
    document
      .getElementById("variant-counter")
      .innerText = counterText;
    togglePrevButton();
  }

  updateCounterInicial();

  // Função para atualizar o contador na interface
  function updateCounter(direcao) {
    if (direcao === "next") {
      currentArrayPosition++;
    } else {
      currentArrayPosition--;
    }

    togglePrevButton();
    toggleNextButton();

    console.log("Entrou dentro do updateCounter");
    var counterText = "Selecionando " + currentArrayPosition + " de " +
      maxSelections + " peças";
    document
      .getElementById("variant-counter")
      .innerText = counterText;

    // Se currentArrayPosition for igual a maxSelections, mostra o botão "Adicionar
    // ao Carrinho"
    if (currentArrayPosition === maxSelections) {
      document.getElementById("add-to-cart-btn").disabled = false;
      console.log(
        'Classe "hidden" removida do botão "Adicionar ao Carrinho com Kit"'
      );
    }
  }

  // Função para desativar o botão "previous"
  function disablePrevButton() {
    const prevButton = document.getElementById("prev-variant-btn");
    prevButton.disabled = true;
    console.log('Botão "previous" desativado');
  }

  // Função para ativar o botão "previous"
  function enablePrevButton() {

    if (currentArrayPosition === 1) {
      const prevButton = document.getElementById("prev-variant-btn");
      prevButton.disabled = true;
      console.log('Botão "previous" desativado');

    } else {

      const prevButton = document.getElementById("prev-variant-btn");
      prevButton.disabled = false;
      console.log('Botão "previous" ativado');

    }

  }

  // Função para verificar a posição atual e alternar o estado do botão "previous"
  function togglePrevButton() {
    console.log(`togglePrevButton: currentArrayPosition = ${currentArrayPosition}`);

    if (currentArrayPosition === 1) {
      console.log(currentArrayPosition)
      disablePrevButton();
    } else {
      enablePrevButton();
    }
  }
  togglePrevButton();

  // Função para desativar o botão "next"
  function disableNextButton() {
    const nextButton = document.getElementById("next-variant-btn");
    nextButton.disabled = true;
    console.log('Botão "next" desativado');
  }

  // Função para ativar o botão "next"
  function enableNextButton() {

    if (currentArrayPosition === maxSelections) {
      const nextButton = document.getElementById("next-variant-btn");
      nextButton.disabled = true;
      console.log('Botão "next" ativado');

    } else {
      const nextButton = document.getElementById("next-variant-btn");
      nextButton.disabled = false;
      console.log('Botão "next" ativado');
    }

  }

  // Função para desativar ou ativar o botão "next"
  function toggleNextButton() {
    console.log(
      `toggleNextButton: currentArrayPosition = ${currentArrayPosition}, maxSelections = ${maxSelections}`
    );

    if (currentArrayPosition === maxSelections) {
      disableNextButton();
    } else {
      enableNextButton();
    }
  }

  // Função para lidar com o clique no botão "Anterior"
  document
    .getElementById("prev-variant-btn")
    .addEventListener("click", function () {
      logAllVariations();
      voltarCarrossel();

      console.log("Botão 'Anterior' clicado.");

      // Verifica se há uma variação na posição `currentArrayPosition - 1` e a
      // recupera
      const prevPositionVariant = selectedVariations[currentArrayPosition - 1];
      console.log("Variação anterior recuperada:", prevPositionVariant);

      console.log("Dados da variação anterior:", prevPositionVariant);
      console.log("Dados da variação atual:", currentSelectedVariant);

      // Verifica se a variação anterior é diferente da variação selecionada
      // atualmente
      if (prevPositionVariant && prevPositionVariant.variantId !== currentSelectedVariant.variantId) {
        console.log(
          "Variação atual é diferente da anterior. Alterando a interface para a variação " +
          "anterior."
        );

        // Altera a interface chamando a função `selectVariantByTitleAndFilho` com a
        // variação anterior
        selectVariantByTitleAndFilho(
          { title: prevPositionVariant.title, itemSelecionado: prevPositionVariant.itemSelecionado }
        );
      } else {
        console.log(
          "A variação atual é igual à anterior ou não há variação anterior. Não há necess" +
          "idade de alterar a interface."
        );
      }

      // Salva a variação atual
      console.log("Salvando a variação atual:");
      console.log("Produto ID:", currentSelectedVariant.productId);
      console.log("Variação ID:", currentSelectedVariant.variantId);
      console.log("Título:", currentSelectedVariant.title);

      // Atualiza o contador para a posição anterior
      console.log("Atualizando o contador para a posição anterior.");
      updateCounter("prev");

      console.log("Processo do botão 'Anterior' concluído.");
      logAllVariations()

      clearAndClickSpecificSelections();

    });

  // Função para lidar com o clique no botão "Próximo"
  document
    .getElementById("next-variant-btn")
    .addEventListener("click", function () {
      logAllVariations();
      ativarCarrossel();

      console.log("Botão 'Próximo' clicado.");

      // Verifica se há uma variação na posição `currentArrayPosition + 1` e a
      // recupera
      const nextPositionVariant = selectedVariations[currentArrayPosition + 1];
      console.log("Próxima variação recuperada:", nextPositionVariant);

      // Verifica se a próxima variação é diferente da variação selecionada atualmente
      if (nextPositionVariant && nextPositionVariant.variantId !== currentSelectedVariant.variantId) {
        console.log(
          "Variação atual é diferente da próxima. Alterando a interface para a variação p" +
          "róxima."
        );

        // Altera a interface chamando a função `selectVariantByTitleAndFilho` com a
        // variação próxima
        selectVariantByTitleAndFilho(
          { title: nextPositionVariant.title, itemSelecionado: nextPositionVariant.itemSelecionado }
        );
      } else {
        console.log(
          "A variação atual é igual à próxima ou não há variação próxima. Não há necessid" +
          "ade de alterar a interface."
        );
      }

      // Atualiza o contador para a próxima posição
      console.log("Atualizando o contador para a próxima posição.");
      updateCounter("next");

      console.log("Processo do botão 'Próximo' concluído.");
      logAllVariations()
      clearAndClickSpecificSelections();

      disableNextButton();


      
    });

  function saveSelectedVariation(productId, variantId, title) {
    console.log("entrou na saveSelectedVariation");

    // Salva a nova variação na posição atual
    selectedVariations[currentArrayPosition] = {
      productId,
      variantId,
      title,
      itemSelecionado
    };

    console.log(
      `Variação salva na posição ${currentArrayPosition}:`,
      productId,
      variantId,
      title,
      `Item Selecionado: ${itemSelecionado}`
    );

    // Loga todas as variações salvas
    logAllVariations();
  }

  // Função auxiliar para logar todas as variações salvas no array
  function logAllVariations() {
    console.log("=== Todas as Variações Salvas ===");
    selectedVariations.forEach((variation, index) => {
      if (variation) {
        console.log(`Posição ${index}:`, variation);
      } else {
        console.log(`Posição ${index}: Vazio`);
      }
    });
    console.log("=================================");
  }

  // Captura todas as opções de rádio da página e adiciona um evento de escuta a
  document
    .querySelectorAll('input[type="radio"]')
    .forEach(function (input) {
      console.log("aplicou funcao ao botao");

      input.addEventListener("change", function (event) {
        if (isSimulatedClick) {
          console.log("Clique simulado detectado, retornando sem executar a função.");
          return; // Ignora se for um clique simulado
        }

        console.log("botao clicado");

        // Adiciona um pequeno delay para garantir que o estado visual do DOM esteja
        // atualizado
        setTimeout(() => {
          var productId = event
            .target
            .closest("[data-product-id]")
            .dataset
            .productId;

          // Encontra o elemento 'variant-picker' mais próximo e obtém o JSON das
          // variantes dentro do <script> correspondente
          var selectedVariantId = event
            .target
            .closest("variant-picker")
            .querySelector("script[data-variant-picker-variants]")
            .textContent;

          // Converte o JSON das variantes para um objeto JavaScript
          var variants = JSON.parse(selectedVariantId);

          // Loga todas as variantes disponíveis para depuração
          console.log("Variantes disponíveis:", variants);

          // Calcula o índice dinamicamente usando a função calcularIndice
          var indiceCalculado = calcularIndice();

          // Verifica se o cálculo do índice foi bem-sucedido
          if (indiceCalculado !== null && variants[indiceCalculado]) {
            // Acessa a variante da linha calculada
            specificVariant = variants[indiceCalculado];

            // Cria um objeto para armazenar a variante selecionada
            currentSelectedVariant = {
              productId: productId, // ID do produto atual
              variantId: specificVariant.id, // ID da variante calculada
              title: specificVariant.title
            };

            // Loga a variante selecionada com todas as informações
            console.log("Dados da variante selecionada:", {
              productId: currentSelectedVariant.productId,
              variantId: currentSelectedVariant.variantId,
              title: currentSelectedVariant.title
            });

            // Loga a variação selecionada, o valor calculado e a linha completa da variação
            console.log("Variação calculada selecionada:", currentSelectedVariant);
            console.log("Valor do índice calculado:", indiceCalculado);
            console.log("Linha completa da variação:", specificVariant);

            // Chama a função para salvar a variação selecionada, passando o ID do produto
            isChangeClick = true;
            saveSelectedVariation(productId, specificVariant.id, specificVariant.title);
            isChangeClick = false;
          } else {
            console.log("Não foi possível encontrar a variante com o índice calculado.");
          }
        }, 100); // Delay de 100ms
      });
    });

  function getVariantIndice() {
    console.log("entrou na getVariantIndice");
    const variantGroups = document.querySelectorAll(
      ".product-variant-picker__pill-list"
    );
    console.log("Grupos de variantes encontrados:", variantGroups.length);

    // Verifica o valor da variável global itemSelecionado
    if (typeof itemSelecionado === "undefined") {
      console.log("Variável itemSelecionado não está definida.");
      return null;
    }

    console.log("Valor de itemSelecionado:", itemSelecionado);

    const extractedNumbers = {};

    // Função para processar um grupo de variantes
    function processVariantGroup(group, groupNumber) {
      const selectedLabel = group.querySelector("label.selected");

      if (selectedLabel && selectedLabel.hasAttribute("no-available")) {
        disableNextButton();

        disablePrevButton();
        console.log(`Grupo ${groupNumber} - Produto não disponível.`);
      } else {

        enablePrevButton();
        enableNextButton();
        console.log(`Grupo ${groupNumber} - Produto disponível.`);
      }

      console.log(
        `Grupo ${groupNumber} - Label selecionado encontrado:`,
        selectedLabel
      );

      if (selectedLabel) {
        var productId = selectedLabel
          .closest("[data-product-id]")
          .dataset
          .productId;
        var labelForAttr = selectedLabel.getAttribute("for");
        var regex = new RegExp(`${productId}-(\\d+)-(\\d+)`);
        var match = labelForAttr.match(regex);

        if (match) {
          var numero1 = match[1];
          var numero2 = match[2];
          extractedNumbers[`group${groupNumber}`] = {
            numero1,
            numero2
          };
          console.log(`Grupo ${groupNumber} - Números filtrados:`, { numero1, numero2 });
        } else {
          console.log(
            `Grupo ${groupNumber} - Nenhum número encontrado no atributo "for".`
          );
        }
      } else {
        console.log(`Grupo ${groupNumber} - Nenhum label selecionado encontrado.`);
      }

      const lastLabel = group.querySelector("label:last-child");
      console.log(`Grupo ${groupNumber} - Último label encontrado:`, lastLabel);

      if (lastLabel) {
        var lastLabelForAttr = lastLabel.getAttribute("for");
        var lastMatch = lastLabelForAttr.match(regex);

        if (lastMatch) {
          var tamanho = lastMatch[2];
          extractedNumbers[`tamanhoGrupo${groupNumber}`] = tamanho;
          console.log(`Grupo ${groupNumber} - Tamanho filtrado:`, tamanho);
        } else {
          console.log(`Grupo ${groupNumber} - Nenhum número encontrado no último label.`);
        }
      }
    }

    // Seleciona os grupos a serem processados com base no itemSelecionado
    if (itemSelecionado === "Filho 1") {
      if (variantGroups.length >= 2) {
        console.log("Processando grupos 1 e 2 para Filho 1");
        processVariantGroup(variantGroups[0], 1);
        processVariantGroup(variantGroups[1], 2);
      } else {
        console.log("Menos de dois grupos de variantes encontrados para Filho 1.");
        return null;
      }
    } else if (itemSelecionado === "Filho 2") {
      if (variantGroups.length >= 4) {
        console.log("Processando grupos 3 e 4 para Filho 2");
        processVariantGroup(variantGroups[2], 3);
        processVariantGroup(variantGroups[3], 4);
      } else {
        console.log("Menos de quatro grupos de variantes encontrados para Filho 2.");
        return null;
      }
    } else {
      console.log("Valor de itemSelecionado não reconhecido:", itemSelecionado);
      return null;
    }

    console.log("Números extraídos e retornados:", extractedNumbers);
    return extractedNumbers;
  }

  // Função que calcula o índice com base nos números extraídos
  function calcularIndice() {
    console.log("entrou na calcularIndice");

    const numeros = getVariantIndice();
    console.log("Dados recebidossss:", numeros);

    if (numeros) {

      let numero2Grupo1;
      let numero2Grupo2;
      let tamanhoGrupo2;

      // Extrai e loga os números recebidos
      if (itemSelecionado === "Filho 2") {
        numero2Grupo1 = parseInt(numeros.group3.numero2, 10);
        numero2Grupo2 = parseInt(numeros.group4.numero2, 10);
        tamanhoGrupo2 = parseInt(numeros.tamanhoGrupo4, 10) + 1;
      } else {
        numero2Grupo1 = parseInt(numeros.group1.numero2, 10);
        numero2Grupo2 = parseInt(numeros.group2.numero2, 10);
        tamanhoGrupo2 = parseInt(numeros.tamanhoGrupo2, 10) + 1;
      }

      console.log("Números recebidos:");
      console.log("Número 2 do Grupo 1:", numero2Grupo1);
      console.log("Número 2 do Grupo 2:", numero2Grupo2);
      console.log("Tamanho do Grupo 2:", tamanhoGrupo2);

      // Calcula o índice com a fórmula fornecida
      const indiceCalculado = numero2Grupo1 * tamanhoGrupo2 + numero2Grupo2;

      // Loga o valor calculado
      console.log("Valor do índice calculado:", indiceCalculado);

      return indiceCalculado;
    } else {
      console.log("Erro ao calcular índice: números de variantes não encontrados.");
      return null;
    }
  }

  function moverParaInfoGeral2() {
    const navKit = document.getElementById("nav_kit");
    const infoGeral2 = document.getElementById("info_geral2");

    if (navKit && infoGeral2) {
      infoGeral2.appendChild(navKit);
    } else {
      console.error("Elemento com id 'nav_kit' ou 'info_geral2' não encontrado.");
    }
  }
  function moverParaInfoGeral1() {
    const navKit = document.getElementById("nav_kit");
    const infoGeral1 = document.getElementById("info_geral1");

    if (navKit && infoGeral1) {
      infoGeral1.appendChild(navKit);
    } else {
      console.error("Elemento com id 'nav_kit' ou 'info_geral1' não encontrado.");
    }
  }
  moverParaInfoGeral1();


  function configurarBotoesFilho1e2() {
    console.log("Função configurarBotoesFilho1e2 executada");

    // Função para atualizar o estado dos botões e o conteúdo
    const atualizarSelecao = (selecionado) => {
      if (itemSelecionado !== selecionado) {
        itemSelecionado = selecionado; // Atualizar a variável global com o item selecionado
        console.log("Item selecionado mudou para:", itemSelecionado);
      }

      const isFilho1 = itemSelecionado === "Filho 1";

      // Atualizar os estados de todos os botões
      document
        .querySelectorAll(".filho1-btn")
        .forEach((botao) => {
          botao
            .classList
            .toggle("selecionado", isFilho1);
          botao
            .classList
            .toggle("n_selecionado", !isFilho1);
        });

      document
        .querySelectorAll(".filho2-btn")
        .forEach((botao) => {
          botao
            .classList
            .toggle("selecionado", !isFilho1);
          botao
            .classList
            .toggle("n_selecionado", isFilho1);
        });

      // Atualizar a visibilidade do conteúdo
      filho1Contents.forEach((element) => {
        element
          .classList
          .toggle("hidden", !isFilho1);
      });

      filho2Contents.forEach((element) => {
        element
          .classList
          .toggle("hidden", isFilho1);
      });

      // Chamar checkSelectedRadio para verificar a seleção
      checkSelectedRadio();
      console.log("checkSelectedRadio executada após atualização de seleção");
    };

    // Adicionar evento de clique a todos os botões Filho 1 e Filho 2
    document
      .querySelectorAll(".filho1-btn")
      .forEach((botaoFilho1) => {
        botaoFilho1.addEventListener("click", () => {
          atualizarSelecao("Filho 1");
          moverParaInfoGeral1(); // Chama a função para mover para info_geral1
        });
      });

    document
      .querySelectorAll(".filho2-btn")
      .forEach((botaoFilho2) => {
        botaoFilho2.addEventListener("click", () => {
          atualizarSelecao("Filho 2");
          moverParaInfoGeral2(); // Chama a função para mover para info_geral2
        });
      });

    // Define o estado inicial: Filho 1 visível, Filho 2 oculto
    filho1Contents.forEach((element) => {
      element
        .classList
        .remove("hidden");
    });
    filho2Contents.forEach((element) => {
      element
        .classList
        .add("hidden");
    });
  }


  // Chama a função configurada
  configurarBotoesFilho1e2();

  function moverInfoPai() {
    // Pega o elemento com o ID "info_pai"
    const infoPai = document.getElementById("info_pai");

    // Verifica se o elemento foi encontrado
    if (infoPai) {
      // Seleciona o elemento com o ID "info_geral1"
      const infoGeral1 = document.getElementById("info_geral1");

      // Se existir, move "infoPai" para o início de "info_geral1"
      if (infoGeral1) {
        infoGeral1.insertAdjacentElement("afterbegin", infoPai);
        console.log("Elemento 'info_pai' movido para o início de 'info_geral1'.");
      } else {
        console.error("Elemento com ID 'info_geral1' não encontrado.");
      }

      // Cria uma cópia de "infoPai"
      const infoPaiClone = infoPai.cloneNode(true);

      // Seleciona o elemento com o ID "info_geral2"
      const infoGeral2 = document.getElementById("info_geral2");

      // Se existir, insere a cópia no início de "info_geral2"
      if (infoGeral2) {
        infoGeral2.insertAdjacentElement("afterbegin", infoPaiClone);
        console.log("Cópia de 'info_pai' inserida no início de 'info_geral2'.");
      } else {
        console.error("Elemento com ID 'info_geral2' não encontrado.");
      }
    } else {
      console.error('Elemento com ID "info_pai" não encontrado.');
    }
  }

  // Chama a função para executar
  moverInfoPai();

  // Função para encontrar o rádio selecionado e executar a lógica
  function checkSelectedRadio() {
    console.log("Função checkSelectedRadio executada");

    const selectedRadio = document.querySelector('input[type="radio"]:checked');

    if (selectedRadio) {
      console.log("Botão de rádio selecionado:", selectedRadio);

      // Adiciona um pequeno delay para garantir que o estado visual do DOM esteja
      // atualizado
      setTimeout(() => {
        var productId = selectedRadio
          .closest("[data-product-id]")
          .dataset
          .productId;

        // Encontra o elemento 'variant-picker' mais próximo
        var variantPickerElement = selectedRadio.closest("variant-picker");

        // Loga o elemento encontrado pelo 'closest'
        console.log(
          "Elemento 'variant-picker' encontrado pelo closest:",
          variantPickerElement
        );

        // Procura por todos os elementos 'variant-picker' no documento
        var allVariantPickers = document.querySelectorAll("variant-picker");

        // Loga todos os elementos 'variant-picker' encontrados
        if (allVariantPickers.length > 0) {
          console.log("Todos os elementos 'variant-picker' encontrados:");
          allVariantPickers.forEach((picker, index) => {
            console.log(`Variant-picker #${index + 1}:`, picker);
          });
        } else {
          console.log("Nenhum elemento 'variant-picker' encontrado no documento.");
        }

        // Verifica o valor de itemSelecionado para determinar qual 'variant-picker'
        // utilizar
        let selectedVariantPicker;
        if (itemSelecionado === "Filho 1") {
          selectedVariantPicker = allVariantPickers[0]; // Usa o primeiro variant-picker
        } else if (itemSelecionado === "Filho 2") {
          selectedVariantPicker = allVariantPickers[1]; // Usa o segundo variant-picker
        } else {
          console.log("Item selecionado inválido:", itemSelecionado);
          return; // Sai da função se o itemSelecionado não for reconhecido
        }

        // Verifica se o variant-picker selecionado existe
        if (selectedVariantPicker) {
          console.log(
            `Usando o variant-picker correspondente a '${itemSelecionado}':`,
            selectedVariantPicker
          );

          // Obtém o JSON das variantes dentro do <script> correspondente
          var selectedVariantId = selectedVariantPicker
            .querySelector(
              "script[data-variant-picker-variants]"
            )
            .textContent;

          // Converte o JSON das variantes para um objeto JavaScript
          var variants = JSON.parse(selectedVariantId);

          // Loga todas as variantes disponíveis para depuração
          console.log("Variantes disponíveis:", variants);

          // Calcula o índice dinamicamente usando a função calcularIndice
          var indiceCalculado = calcularIndice();

          // Verifica se o cálculo do índice foi bem-sucedido
          if (indiceCalculado !== null && variants[indiceCalculado]) {
            // Acessa a variante da linha calculada
            specificVariant = variants[indiceCalculado];

            // Cria um objeto para armazenar a variante selecionada
            currentSelectedVariant = {
              productId: productId, // ID do produto atual
              variantId: specificVariant.id, // ID da variante calculada
              title: specificVariant.title
            };

            // Loga a variante selecionada com todas as informações
            console.log("Dados da variante selecionada:", {
              productId: currentSelectedVariant.productId,
              variantId: currentSelectedVariant.variantId,
              title: currentSelectedVariant.title
            });

            // Loga a variação selecionada, o valor calculado e a linha completa da variação
            console.log("Variação calculada selecionada:", currentSelectedVariant);
            console.log("Valor do índice calculado:", indiceCalculado);
            console.log("Linha completa da variação:", specificVariant);

            // Chama a função para salvar a variação selecionada, passando o ID do produto e
            // da variante
            saveSelectedVariation(productId, specificVariant.id, specificVariant.title);
          } else {
            console.log("Não foi possível encontrar a variante com o índice calculado.");
          }
        } else {
          console.log(
            `Variant-picker correspondente a '${itemSelecionado}' não encontrado.`
          );
        }
      }, 100); // Delay de 100ms
    }
  }

  checkSelectedRadio();

  function clearAndClickSpecificSelections() {
    // Atraso de 500ms antes de iniciar o processo
    setTimeout(() => {
      console.log(`Iniciando a limpeza da seleção para o item: ${itemSelecionado}`);

      const variantPickers = document.querySelectorAll('.variant_picker_clean');
      let variantPickerToClear;

      if (itemSelecionado === "Filho 1") {
        variantPickerToClear = variantPickers[1];
      } else if (itemSelecionado === "Filho 2") {
        variantPickerToClear = variantPickers[3];
      }

      if (!variantPickerToClear) {
        console.log("Nenhum contêiner correspondente encontrado.");
        return;
      }

      // Seleciona os elementos a serem limpos e salvos para clique posterior
      const selectedOptions = Array.from(
        variantPickerToClear.querySelectorAll('label.selected')
      );
      console.log(
        `Quantidade de opções selecionadas encontradas: ${selectedOptions.length}`
      );

      // Remove a seleção de cada elemento e salva-os para o clique posterior
      selectedOptions.forEach(option => {
        console.log("Limpando seleção do elemento:", option);
        option
          .classList
          .remove('selected');
        option.removeAttribute('tabindex');
        option.removeAttribute('style');

        const associatedInput = document.getElementById(option.getAttribute('for'));
        if (associatedInput && associatedInput.type === 'radio') {
          associatedInput.checked = false;
          console.log("Input de rádio desmarcado:", associatedInput);
        }
      });

      console.log(
        "Seleção limpa. Aguardando 1 segundo antes de clicar novamente em cada elemento" +
        " limpo."
      );

      // Pausa de 1 segundo e, em seguida, realiza o clique em cada elemento
      setTimeout(() => {
        selectedOptions.forEach(option => {
          try {
            option.focus();
            option.click();
            console.log("Clique realizado no elemento:", option);
          } catch (error) {
            console.error("Erro ao tentar clicar no elemento:", error);
          }
        });
      }, 500);
    }, 500); // Atraso inicial de 500ms antes de iniciar o código da função
  }

  async function selectVariantByTitleAndFilho(data) {

    // Função de atraso para pausas
    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // Pausa inicial de 500ms
    await delay(500);
    // Recebe o título e o valor de itemSelecionado que representa o variant picker
    // a ser usado
    const { title, itemSelecionado } = data;

    console.log("Dados recebidos em selectVariantByTitleAndFilho:", data);

    // Divide o título nos dois termos (e.g., "Bordô / M" -> "Bordô" e "M")
    const [firstTerm, secondTerm] = title.split(' / ');

    // Seleciona todos os variant-pickers na página
    const variantPickers = document.querySelectorAll('variant-picker');

    // Identifica o variant picker específico com base no itemSelecionado
    const filhoIndex = itemSelecionado === "Filho 1"
      ? 0
      : 1;
    const selectedVariantPicker = variantPickers[filhoIndex];

    if (!selectedVariantPicker) {
      console.error('Variant picker não encontrado.');
      return;
    }

    // Verifica se os valores já estão selecionados
    const selectedFirstOption = selectedVariantPicker.querySelector(
      '[option-picker-name="Cor"] label.selected'
    );
    const selectedSecondOption = selectedVariantPicker.querySelector(
      '[option-picker-name="Tamanho"] label.selected'
    );

    const isFirstTermSelected = selectedFirstOption && selectedFirstOption
      .textContent
      .trim() === firstTerm;
    const isSecondTermSelected = selectedSecondOption && selectedSecondOption
      .textContent
      .trim() === secondTerm;

    // Condiciona o clique de acordo com o valor de itemSelecionado
    if (itemSelecionado === "Filho 1") {
      const filho1Button = document.querySelector('.filho1-btn');
      if (filho1Button) {

        isSimulatedClick = true;
        console.log('flag true');

        filho1Button.click();
        isSimulatedClick = false;
        console.log('flag false');

        console.log('Clicou no botão "Filho 1".');
      } else {
        console.error('Botão "Filho 1" não encontrado.');
        return;
      }
    } else if (itemSelecionado === "Filho 2") {
      const filho2Button = document.querySelector('.filho2-btn');
      if (filho2Button) {

        isSimulatedClick = true;
        console.log('flag true');
        filho2Button.click();
        isSimulatedClick = false;
        console.log('flag false');

        console.log('Clicou no botão "Filho 2".');
      } else {
        console.error('Botão "Filho 2" não encontrado.');
        return;
      }
    } else {
      console.error(
        'Valor de itemSelecionado inválido. Deve ser "Filho 1" ou "Filho 2".'
      );
      return;
    }

    // Encontra o primeiro grupo de labels (para o primeiro termo)
    const firstGroupLabels = selectedVariantPicker.querySelectorAll(
      '[option-picker-name="Cor"] label'
    );
    let firstLabelFound = null;
    firstGroupLabels.forEach(label => {
      if (label.textContent.trim() === firstTerm) {
        firstLabelFound = label;
      }
    });

    if (!firstLabelFound) {
      console.error(
        `Primeiro termo "${firstTerm}" não encontrado no grupo de cores.`
      );
      return;
    }

    // Clica no label correspondente ao primeiro termo
    isSimulatedClick = true;
    firstLabelFound.click();
    isSimulatedClick = false;
    console.log(`Clicou no termo de cor: ${firstTerm}`);

    // Encontra o segundo grupo de labels (para o segundo termo)
    const secondGroupLabels = selectedVariantPicker.querySelectorAll(
      '[option-picker-name="Tamanho"] label'
    );
    let secondLabelFound = null;
    secondGroupLabels.forEach(label => {
      if (label.textContent.trim() === secondTerm) {
        secondLabelFound = label;
      }
    });

    if (!secondLabelFound) {
      console.error(
        `Segundo termo "${secondTerm}" não encontrado no grupo de tamanhos.`
      );
      return;
    }

    console.log(`vai tetar clicar no: ${secondTerm}`);
    // Clica no label correspondente ao segundo termo
    isSimulatedClick = true;

    secondLabelFound.click();
    isSimulatedClick = false;
    console.log(`Clicou no termo de tamanho: ${secondTerm}`);
    console.log(
      `Variantes selecionadas: ${firstTerm} / ${secondTerm} no ${itemSelecionado}.`
    );

  }





  // Função para gerar uma tag aleatória
  function generateRandomTag() {
    return "bundle_group_" + Math
      .random()
      .toString(36)
      .substring(2, 15);
  }

  // Função para adicionar as variações selecionadas ao carrinho
  function addVariationsToCart(variations, index, maxSelections, randomTag) {
    // Verifica se o índice atual ultrapassa o limite de variações ou o número máximo de seleções
    if (index > maxSelections) {
      console.log("Todas as variações selecionadas foram adicionadas ao carrinho. Finalizando processo.");
     setTimeout(() => {
      window.location.href = "/cart";
    }, 200); // 1000 milissegundos = 1 segundo
      return;
    }

    const variation = variations[index];

    // Verifica se a variação possui um ID de variante válido
    if (!variation || !variation.variantId) {
      console.error(`Erro: variação na posição ${index} está mal formada ou falta 'variantId'.`);
      return;
    }

    const properties = {
      discount_bundle: "true",
      bundle_group: randomTag, // Usa a tag aleatória para agrupar os itens do kit
      qtdKit: maxSelections,
    };

    // Log detalhado da requisição
    console.log(`Adicionando variação ${index + 1}/${maxSelections} ao carrinho:`, {
      id: variation.variantId,
      quantity: 1,
      properties: properties
    });

    // Envia requisição para adicionar a variação ao carrinho
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: variation.variantId,
        quantity: 1,
        properties: properties
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log(`Variação adicionada com sucesso ao carrinho (Produto ID: ${variation.productId}):`, data);

        // Chama recursivamente a função para adicionar a próxima variação
        addVariationsToCart(variations, index + 1, maxSelections, randomTag);
      })
      .catch(error => {
        console.error("Erro ao adicionar variação ao carrinho:", error);
      });
  }

// Função para lidar com o clique no botão "Adicionar ao Carrinho"
function handleAddToCartClick() {
  const randomTag = generateRandomTag();
  const addToCartButton = document.getElementById("add-to-cart-btn");

  // Adiciona a classe de carregamento e altera o texto do botão
  addToCartButton.classList.add("loading");
  addToCartButton.innerText = "Carregando produtos...";
  addToCartButton.removeEventListener("click", handleAddToCartClick);
  addToCartButton.disabled = true;
  console.log("Botão 'Adicionar ao Carrinho' desativado e exibindo estado de carregamento.");

  // Inicia o processo de adição ao carrinho a partir da posição 1
  addVariationsToCart(selectedVariations, 1, maxSelections, randomTag);
}

  // Adiciona o event listener ao botão "Adicionar ao Carrinho"
  document.getElementById("add-to-cart-btn").addEventListener("click", handleAddToCartClick);


});

document.addEventListener("DOMContentLoaded", () => {
  console.log("Página carregada. Verificando quantidade de filhos...");

  // Seleciona todos os variant-pickers da página
  const variantPickers = document.querySelectorAll('variant-picker');

  // Verifica a quantidade de variant-pickers
  if (variantPickers.length > 0) {
    console.log(`Filhos encontrados: ${variantPickers.length}`);

    // Loga as variantes de cada variant-picker
    variantPickers.forEach((variantPicker, index) => {
      const label = `Variantes do Filho ${index + 1}`;
      const variantScript = variantPicker.querySelector('script[data-variant-picker-variants]');

      if (variantScript) {
        try {
          const variants = JSON.parse(variantScript.textContent);
          console.log(`${label}:`, variants);
        } catch (error) {
          console.error(`Erro ao parsear variantes para ${label}:`, error);
        }
      } else {
        console.error(`Elemento <script> com as variantes não encontrado para ${label}.`);
      }
    });
  } else {
    console.log("Nenhum filho encontrado.");
  }
});
